
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetolocalinnovacrystacarrental() {



    const cardData =
    {
        keyword: 'Pune Local Innova Crysta Car Rental',
        heading: 'Meghana Cab : Pune Local Innova Crysta Car Rental',
        headingDescription: 'Meghana Cab offers Pune Local Innova Crysta Car Rental, providing a premium, spacious, and flexible travel solution for your local journeys within Pune. Whether you are attending meetings, shopping, sightseeing, airport transfers, or family outings, our Innova Crysta vehicles deliver unmatched comfort with plush leather interiors, ample legroom, and generous luggage space. With professional and courteous chauffeurs, GPS-enabled tracking, transparent fare structures (hourly or full-day rentals), and door-to-door pickup from any location in Pune, we ensure a smooth, reliable, and stress-free ride. Backed by 24/7 customer support and hassle-free online booking, Meghana Cab guarantees a top-tier local travel experience tailored to your schedule and preferences—ride in style and convenience every time.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "The iconic 18th-century fortification built by Peshwa Baji Rao I in 1732. Although much of it was destroyed by fire in 1828, its grand gateways, fortified walls, fountains, and gardens remain today. It hosts a popular evening light-and-sound show that retells Maratha power struggles and legends."
  },
  {
    "title": "Aga Khan Palace",
    "description": "A majestic Italian-arched palace built in 1892 by Aga Khan III. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. Now a museum and memorial with serene gardens and samadhis, it’s a significant site of India’s freedom struggle."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 30 km southwest of the city, this hill fortress sits 1,317 m above sea level. It is famed for the Battle of Sinhagad (1670) led by Tanaji Malusare. The site offers a rewarding trek, panoramic views, historic gates and memorials, and local food stalls at the top."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "A globally renowned wellness retreat spread across lush Koregaon Park. It provides meditation sessions, spa treatments, workshops, serene Zen gardens, and swimming facilities—ideal for those seeking relaxation and spiritual rejuvenation."
  },
  {
    "title": "Dagadusheth Halwai Ganapati Temple",
    "description": "A century-old temple dedicated to Lord Ganesha, housing an idol adorned with gold and gems. It is the centerpiece of Pune’s Ganesh Chaturthi celebrations and is known for its vibrant devotional rituals and daily aartis."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century monolithic rock-cut Shiva shrine carved from basalt. It features a circular Nandi mandapa with sixteen pillars and a Shiva-lingam sanctum. Nestled near busy Jangli Maharaj Road, it offers a rare heritage oasis amid urban activity."
  },
  {
    "title": "Parvati Hill & Temple",
    "description": "Pune’s second-highest hill (2,100 ft), with a 103-step climb leading to Peshwa-era shrines of Shiva, Vishnu, and Kartikeya. It includes a small museum and offers stunning sunrise and sunset views over the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Founded in memory of Dinkar Kelkar’s son, this museum houses over 20,000 artifacts—from musical instruments to paintings and toys. With geo-fenced audio guides and themed galleries, it invites visitors into India’s cultural mosaic."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in 1630 for Shivaji Maharaj and his mother Jijabai, Lal Mahal is a reconstructed heritage building featuring murals, life-sized statues, and exhibits detailing Shivaji’s early life and Maratha heritage."
  },
  {
    "title": "Koregaon Park",
    "description": "A leafy, upscale neighborhood known for banyan-lined avenues, art galleries, high-end cafés, microbreweries, and nightlife. Once a quiet residential area, it now blends tranquil greenery with cosmopolitan vibrancy."
  }
],

      "services": [
    {
      "name": "Pune Local Innova Crysta Rental",
      "description": "Explore Pune conveniently with our local Innova Crysta rental service. Whether it’s shopping, city errands, or short meetings, our spacious and air-conditioned cabs offer unmatched comfort and flexibility for intracity use."
    },
    {
      "name": "Innova Crysta Taxi for Pune Local Travel",
      "description": "Book an Innova Crysta taxi for local travel in Pune and enjoy smooth city rides. Perfect for daily tasks, visiting multiple destinations, or personal errands, our taxis are available by the hour or for full-day use."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Local",
      "description": "Sit back and relax with our chauffeur-driven Innova Crysta for Pune local travel. Our courteous drivers ensure punctuality, route knowledge, and safety as you move across the city for business or leisure."
    },
    {
      "name": "Affordable Innova Crysta Pune Local Rental",
      "description": "Get the best value with our affordable local rental plans for Innova Crysta in Pune. Ideal for short-term use, our packages are budget-friendly while maintaining premium service and vehicle quality."
    },
    {
      "name": "Family Innova Crysta Taxi Pune Local",
      "description": "Travel with your family across Pune in our comfortable 6- or 7-seater Innova Crysta. With child-friendly features, clean interiors, and AC comfort, it’s perfect for local family outings and functions."
    },
    {
      "name": "Online Innova Crysta Pune Local Booking",
      "description": "Book a local Innova Crysta online in Pune with ease. Our platform allows quick scheduling, fare estimates, and instant confirmations—perfect for spontaneous plans or daily travel."
    },
    {
      "name": "Corporate Innova Crysta Pune Local Hire",
      "description": "For meetings, hotel transfers, or office runs, choose our corporate local Innova Crysta hire service in Pune. Executive seating, professional drivers, and timely pickups make it ideal for business use."
    },
    {
      "name": "Pune Local City Innova Crysta Cab",
      "description": "Hire an Innova Crysta for city travel in Pune and experience a premium cab service. From Baner to Hadapsar or Hinjewadi to Kothrud, we cover all areas with flexible rental packages."
    },
    {
      "name": "Hourly Innova Crysta Rental Pune",
      "description": "Need a cab for just a few hours? Our hourly Innova Crysta rental service in Pune lets you pay only for the time you use. Ideal for events, meetings, or short visits within the city."
    },
    {
      "name": "Local Sightseeing Innova Crysta Pune",
      "description": "Discover Pune's heritage and modern attractions in comfort with our sightseeing Innova Crysta package. Visit Aga Khan Palace, Shaniwar Wada, Saras Baug, and more with a driver who knows the city well."
    },
    {
      "name": "Innova Crysta for Local Errands Pune",
      "description": "Running errands around Pune? Hire our Innova Crysta taxi to ensure a comfortable, quick, and hassle-free experience. We provide flexible pickup points and stops across the city."
    },
    {
      "name": "Comfortable Local Innova Crysta Cab",
      "description": "Our local Innova Crysta cabs in Pune are designed for comfort and space. Adjustable seats, clean interiors, and a smooth ride make them the top choice for daily or occasional travel."
    },
    {
      "name": "Pune Local AC Taxi Innova Crysta",
      "description": "Beat the heat with our fully air-conditioned Innova Crysta taxis for local Pune travel. Whether you’re headed to a meeting, market, or school run, travel in cool comfort year-round."
    },
    {
      "name": "Local Innova Crysta Hire with Driver Pune",
      "description": "Hire an Innova Crysta with a skilled driver for your local travel needs in Pune. Ideal for guests, seniors, or busy professionals needing convenient point-to-point city transfers."
    },
    {
      "name": "Flexible Innova Crysta Rental Pune",
      "description": "Our flexible Innova Crysta rental plans in Pune allow you to customize your booking based on hours, distance, or purpose—perfect for unpredictable schedules or multipoint city travel."
    }
  ],
  "tableData": [
    ["Pune Local Innova Crysta Rental", "Innova Crysta Taxi for Pune Local Travel"],
    ["Chauffeur Driven Innova Crysta Pune Local", "Affordable Innova Crysta Pune Local Rental"],
    ["Family Innova Crysta Taxi Pune Local", "Online Innova Crysta Pune Local Booking"],
    ["Corporate Innova Crysta Pune Local Hire", "Pune Local City Innova Crysta Cab"],
    ["Hourly Innova Crysta Rental Pune", "Local Sightseeing Innova Crysta Pune"],
    ["Innova Crysta for Local Errands Pune", "Comfortable Local Innova Crysta Cab"],
    ["Pune Local AC Taxi Innova Crysta", "Local Innova Crysta Hire with Driver Pune"],
    ["Flexible Innova Crysta Rental Pune", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Premium Innova Crysta Car Rental for Pune Local Travel",
    "WhyChoosedescription": "Rent an Innova Crysta for comfortable and hassle-free local travel within Pune. Whether it’s a business meeting, family outing, wedding event, or sightseeing tour, our rental service ensures a luxurious ride around the city with professional service."
  },
  {
    "WhyChooseheading": "Spacious and Luxurious City Ride",
    "WhyChoosedescription": "Our Innova Crysta vehicles feature plush seating, dual-zone AC, smooth suspension, and ample legroom—ideal for up to 6–7 passengers. It's perfect for full-day city usage, offering unmatched comfort on busy Pune roads."
  },
  {
    "WhyChooseheading": "Flexible Hourly and Full-Day Packages",
    "WhyChoosedescription": "We offer easy booking options like 4-hour, 8-hour, and full-day packages for city travel. Whether you're running errands, attending meetings across town, or planning a day tour, we have flexible plans to suit your schedule."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs with City Route Expertise",
    "WhyChoosedescription": "Our drivers are punctual, courteous, and experienced in navigating Pune’s local areas. They ensure smooth point-to-point transfers, on-time arrivals, and safe driving through traffic-heavy zones like Hinjewadi, Kharadi, or Deccan."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Vehicles",
    "WhyChoosedescription": "All our Innova Crysta cabs are cleaned and sanitized before every trip. We follow strict hygiene protocols and regular maintenance schedules to ensure a safe and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Ideal for Corporate, Family, and VIP Use",
    "WhyChoosedescription": "Whether you're hosting a guest, arranging team travel, or planning a family day out, our Innova Crysta rental fits every need. It's also the go-to choice for weddings, hotel pickups, and executive-level transport."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
    "WhyChoosedescription": "Our local rental rates are clear and inclusive of driver allowance, fuel for the package limit, and all taxes. You’ll receive full fare details upfront—no surprises or hidden charges at the end of your trip."
  },
  {
    "WhyChooseheading": "24/7 Customer Support and Quick Booking Assistance",
    "WhyChoosedescription": "Our support team is available any time of day to help you with bookings, time extensions, or route suggestions. Enjoy seamless service and instant confirmations through phone or online booking."
  }
]















    }

const faqData = [
    {
        question: "How can I rent an Innova Crysta for local travel in Pune?",
        answer: "You can book a local Innova Crysta by calling Meghana Cab at +91 9075462128 or through our website."
    },
    {
        question: "What are the rental packages available for local Pune travel?",
        answer: "We offer hourly packages such as 4 hours/40 km, 8 hours/80 km, and full-day options tailored to your needs."
    },
    {
        question: "Is the Innova Crysta suitable for local travel within Pune?",
        answer: "Yes, the Innova Crysta is ideal for city travel, providing ample space, comfort, and air conditioning for all passengers."
    },
    {
        question: "What is included in the local rental fare?",
        answer: "The fare includes fuel, driver charges, and a fixed number of kilometers. Additional charges apply for extra km or hours."
    },
    {
        question: "Can I use the rental for multiple stops in Pune?",
        answer: "Yes, the car is at your service for the booked duration, and you can make multiple stops as needed."
    },
    {
        question: "Are your Innova Crysta cabs sanitized before every ride?",
        answer: "Absolutely. All our vehicles are cleaned and sanitized before each trip to ensure a hygienic experience."
    },
    {
        question: "Is the driver experienced and professional?",
        answer: "Yes, all our drivers are licensed, courteous, and familiar with Pune’s routes and landmarks."
    },
    {
        question: "Can I extend the rental duration during the trip?",
        answer: "Yes, you can extend the time based on availability. Extra hours will be charged accordingly."
    },
    {
        question: "What payment options are available for local rentals?",
        answer: "We accept UPI, debit/credit cards, net banking, and cash."
    },
    {
        question: "Is the rental service available 24/7 in Pune?",
        answer: "Yes, our local rental service is available anytime, day or night, with advance booking."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Abhishek Nair',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Used Meghana Cab’s Innova Crysta for a full-day Pune city tour. Smooth experience and very comfortable ride.”',
    },
    {
        name: 'Ms. Jyoti Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Best local rental service in Pune. The Innova Crysta was clean, punctual, and the driver was helpful throughout.”',
    },
];



























































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const puneLocalInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune Local Innova Crysta Car Rental",
  "description": "Affordable chauffeur-driven Innova Crysta car rental for local travel in Pune. Ideal for family trips, corporate travel, local errands, and sightseeing with flexible hourly rentals.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Local Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-local-innova-crysta-car-rental"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune Local Innova Crysta Car Rental | Chauffeur Driven Taxi Service</title>
  <meta
    name="description"
    content="Book affordable and comfortable Innova Crysta car rental for local travel in Pune. Chauffeur-driven, flexible hourly service for family, corporate, and sightseeing needs."
  />
  <meta
    name="keywords"
    content="Pune Local Innova Crysta Rental, Innova Crysta Taxi for Pune Local Travel, Chauffeur Driven Innova Crysta Pune Local, Affordable Innova Crysta Pune Local Rental, Family Innova Crysta Taxi Pune Local, Online Innova Crysta Pune Local Booking, Corporate Innova Crysta Pune Local Hire, Pune Local City Innova Crysta Cab, Hourly Innova Crysta Rental Pune, Local Sightseeing Innova Crysta Pune, Innova Crysta for Local Errands Pune, Comfortable Local Innova Crysta Cab, Pune Local AC Taxi Innova Crysta, Local Innova Crysta Hire with Driver Pune, Flexible Innova Crysta Rental Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneLocalInnovaSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/20.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetolocalinnovacrystacarrental;